import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="wrap pad">
      <h1>Nothing here</h1>
      <p>That page does not exist, or the listing is not published yet.</p>
      <Link className="btn" to="/directory">
        Browse the directory
      </Link>
    </div>
  );
}
